<template>
  <div id="slider">
    <v-slider
      v-model="volume"
      :step="step"
      :max="maxSliderValue"
      :min="minSliderValue"
      @input="changeSlider"
      tick-size="3"
      ticks="always"
    >
    </v-slider>
    <div class="hint">
      <div class="hint-item">{{minValue}}</div>
      <div class="hint-item">{{maxValue}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'SliderControl',
  data() {
    return {
      minValue: '5GB',
      maxValue: '500GB',
      minSliderValue: 0,
      maxSliderValue: 8,
      inputSize: 'mini',
      volume: 0,
      step: 1
    }
  },
  computed: {
    ...mapState(['volumeValue'])
  },
  methods: {
    changeSlider() {
      this.$store.dispatch('changeSlider', this.volume)
    },
    endChangeSlider() {
      this.$store.dispatch('endChangeSlider')
    }
  }
};
</script>
<style lang="scss" scoped>
#slider {
  margin-bottom: 10px;
}
.hint {
  display: flex;
  justify-content: space-between;
  &-item {
    color: #333940;
    font-size: 16px;
  }
}
::v-deep  .v-input__slot {
  margin-bottom: 5px;
}
::v-deep .hint-volume {
  font-size: 12px;
}
::v-deep  .v-messages {display: none;}
::v-deep .v-slider__track-container {
  height: 3px;
}
::v-deep .v-slider__track {
  height: 3px;
}
::v-deep .v-slider__thumb {
  width: 16px;
  height: 16px;
  left: -8px
}
::v-deep .v-slider__thumb:before {
  left: -10px;
  top: -10px;
}
::v-deep .v-slider__tick {
  background-color: #377ab4;
  top: calc(50% - 2px) !important;
  width: 3px !important;
  height: 3px !important;
}
::v-deep .v-application .primary,
::v-deep .v-application .primary--text{
  background-color:  #377ab4 !important;
  border-color:  #377ab4 !important;
}
::v-deep .v-application .primary.lighten-3 {
  background-color: #DCE9F3 !important;
}
</style>
